import { Button } from '@factorialco/deprecated-design-system'
import {
  ProjectDocumentsDataCollectionDocument,
  SoftDeleteProjectDocumentsDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export interface DeleteDocumentsModalProps {
  onCloseModal: () => void
  ids: string[]
  projectId: string
}

export const DeleteDocumentsModal = ({
  onCloseModal,
  ids,
  projectId,
}: DeleteDocumentsModalProps) => {
  const [softDeleteProjectDocument] = useMutation(SoftDeleteProjectDocumentsDocument, {
    extractorFn: (mutation) =>
      mutation.projectManagementMutations.softDeleteProjectmanagementProjectDocument,
    refetchQueries: [ProjectDocumentsDataCollectionDocument],
    awaitRefetchQueries: true,
  })

  const onSubmitModal = async () => {
    const result = await softDeleteProjectDocument({ variables: { ids, projectId } })
    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      track(trackingEvents.projectManagement.projectFiles.clickOnConfirmDeleteFile)
      onCloseModal()
    }
  }

  const description =
    ids.length > 1
      ? i18n.t('project_management.files.datacollection.delete_modal.description_multiple', {
          files_number: ids.length,
        })
      : i18n.t('project_management.files.datacollection.delete_modal.description')
  return (
    <Modal
      illustration={'delete'}
      title={i18n.t('project_management.files.datacollection.delete_modal.title')}
      description={description}
      onClose={onCloseModal}
      onSubmit={() => onSubmitModal()}
      footer={
        <>
          <Button
            type="secondary"
            onClick={() => {
              track(trackingEvents.projectManagement.projectFiles.clickOnCancelDeleteFile)
              onCloseModal()
            }}
          >
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onSubmitModal}>{i18n.t('common.delete')}</Button>
        </>
      }
    />
  )
}
